import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ApiService from '../../Api/ApiController';
import Swal from 'sweetalert2';
export default function UpdateProfile() {
 const [password,setPassword] = useState();
 const [adminId,setAdminId] = useState();
    const getAdmin = ()=>{
        ApiService.getAdmin().then((response)=>{
            if(response.data.status === true){
              setPassword(response.data.data.password);
              setAdminId(response.data.data._id);
            }
        }).catch((error)=>{
            console.log(error)
        })
    }
    useEffect(()=>{
      getAdmin()
    },[]);

    const updatePassword = (e)=>{
        e.preventDefault()
       ApiService.updatepassword({
        password,
        admin_id:adminId
       }).then((response)=>{
        if(response.data.status === true){
             Swal.fire({
                          toast: true,
                          position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
                          icon: 'success',
                          title: response.data.message,
                          showConfirmButton: false,
                          timer: 3000, // Duration in milliseconds
                          timerProgressBar: true,
                        });
        }else{
             Swal.fire({
                          toast: true,
                          position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
                          icon: 'error',
                          title: response.data.message,
                          showConfirmButton: false,
                          timer: 3000, // Duration in milliseconds
                          timerProgressBar: true,
                        });
        }
       }).catch((error)=>{
        console.log(error)
         Swal.fire({
                      toast: true,
                      position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
                      icon: 'error',
                      title: error.response.data.message,
                      showConfirmButton: false,
                      timer: 3000, // Duration in milliseconds
                      timerProgressBar: true,
                    });
       })
    }
  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8, textAlign: 'center' }}>
    <Typography variant="h4" gutterBottom>
      Change Password
    </Typography>
  <TextField
         label="Password"
        //  type="password"
         variant="outlined"
         fullWidth
         margin="normal"
         value={password}
         onChange={(e)=>setPassword(e.target.value)}

       />
    <Button variant="contained" color="primary" onClick={updatePassword}  fullWidth sx={{ mt: 2 }}>
      Submit
    </Button>
  </Box>
  )
}
